import { useEffect, useRef } from "react";
import { useShellStore } from "@/shared/layout/shell.store";

/**
 * Marks a full-size Book button as on screen while it is, so the floating one steps aside rather than
 * covering it (design note salon-home-landing.md section 5 item 1). Without IntersectionObserver
 * (jsdom, very old browsers) nothing changes and the floating button stays.
 */
export function useInlineBook<T extends Element>() {
  const ref = useRef<T>(null);
  const setVisible = useShellStore((state) => state.setInlineBookVisible);

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof IntersectionObserver !== "function") return;
    const observer = new IntersectionObserver(([entry]) => setVisible(entry?.isIntersecting ?? false));
    observer.observe(element);
    return () => {
      observer.disconnect();
      setVisible(false);
    };
  }, [setVisible]);

  return ref;
}
